<template>
	<div>

        <config-main-title v-if="!setup">
            Prestadores
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="form-row mb-0" v-if="!setup">
                <div class="col col-12 col-md-3">
                    <az-input icon="fas fa-filter"
                        type="select"
                        optionsMode="esp-ativas"
                        optionsName="esp-ativas"
                        placeholder="Todas"
                        v-model="especialidade" />
                </div>
                <div class="col col-12 col-md-3">
                    <az-input 
                        icon="fas fa-search" 
                        ref="pesquisa" 
                        v-model="search"
                        @input="selecionado = null"
                        @onArrowDown="onArrowDown"
                        @onArrowUp="onArrowUp"
                        @onEnter="onEnter">
                        <template v-slot:buttonposb>
                            <importacao service="medicos" @refresh="load()" />
                            <div class="input-group-append">
                                <button type="button" class="btn btn-outline-primary" @click="addNewItem ()">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <az-input
                        icon="fa-solid fa-certificate fa-fw"
                        type="select"
                        placeholder="Todos..."
                        :optionsList="[
                            { id: 'S', search: 'Com Certificado Digital' }, 
                            { id: 'A', search: 'Com Certificado Digital Ativo' }, 
                            { id: 'V', search: 'Com Certificado Digital Vencido' }, 
                            { id: 'P', search: 'Com Certificado Digital Vencendo (30d)' }, 
                            { id: 'N', search: 'Sem Certificado Digital' }, 
                        ]"
                        optionsData="id"
                        v-model="filtro_certificado"
                        @input="load()" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn text-nowrap" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn text-nowrap" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'"
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
            </div>

            <div class="mb-0 d-flex flex-column" v-else-if="lista_dados.length">
                <button type="button" class="btn btn-primary" @click="addNewItem ()">
                    <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                    Incluir Profissional
                </button>
            </div>

        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading"></div>
            <div class="determinate" v-else></div>
        </div>

		<div v-if="!em_edicao && !lista_dados.length">
            <az-empty-state action="Incluir"
                msg="Nenhum prestador identificado."
                icon="fa fa-user-md"
                :method="addNewItem" />
		</div>

        <div v-if="!em_edicao && lista_dados.length">

            <div class="alert alert-warning" v-if="anexos_vencidos && anexos_vencidos.length">
                <a href="#" @click.prevent="ver_vencidos = !ver_vencidos" class="alert-link">
                    {{ anexos_vencidos.length }} arquivo(s) vencido(s)
                </a>
            </div>

            <div class="list-group mb-3 az-anime-surgir mb-3" v-if="!em_edicao">
                <li class="list-group-item d-flex justify-content-between hover-bg" 
                    :class="( prestador.medico_unidade && prestador.medico_unidade.fl_ativo ? '' : 'list-group-item-secondary' ) + ( ip === selecionado ? 'active' : '' )"
                    v-for="(prestador, ip) in lista_dados" :key="ip">
                    <span>
                        <a href="#" @click.prevent="editar(prestador)" class="h5 card-link mb-0 mr-3" :class="ip === selecionado ? 'text-white' : ''">
                            {{ prestador.st_nome_exibicao }}
                        </a>
                        <span class="text-muted mr-4">{{ prestador.conselho.st_sigla }} {{ prestador.in_numero_conselho }}-{{ prestador.estado_conselho.st_sigla }}</span>
                        <small class="text-muted" v-for="(esp, ie) in prestador.medico_especialidade" :key="ie">
                            <span v-if="ie">/</span>
                            {{ esp.especialidade.st_especialidade }}
                            <template v-if="especialidade && esp.js_classes && especialidade.id_especialidade == esp.id_especialidade">
                                <span v-for="(sub, isx) in esp.js_classes" :key="isx" class="badge badge-success mr-1">
                                    {{ sub }}
                                </span>
                            </template>
                        </small>
                        <span v-if="!prestador.medico_especialidade.length"
                            data-toggle="tooltip" data-placement="top" title="Nenhuma especialidade habilitada.">
                            <i class="fa fa-exclamation-triangle text-warning" aria-hidden="true"></i>
                        </span>

                        <div v-if="prestador.js_classes">
                            <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                v-for="(tag, itx) in prestador.js_classes" :key="itx">
                                <span class="badge badge-success mr-1">
                                    {{ tag }}
                                </span>
                            </a>
                        </div>
                    </span>
                    <span v-if="prestador.medico_unidade">
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" :id="'ativo' + ip"
                                v-model="prestador.medico_unidade.fl_ativo" @change="toggle_medico(prestador.medico_unidade)">
                            <label class="custom-control-label" :for="'ativo' + ip"></label>
                        </div>

                        <div v-else class="d-flex">
                            <div>
                                <span v-if="filtro_certificado && prestador.tem_certificado && prestador.certificado_validade" 
                                    class="badge mr-2" :class="'badge-' + prestador.certificado_vencido"
                                    title="Validade do Certificado">
                                    {{ $util.getFormatDate(prestador.certificado_validade) }}
                                </span>

                                <span v-if="prestador.tem_certificado && prestador.certificado_vencido" class="mr-2" title="Certificado Digital">
                                    <i class="fa-solid fa-certificate" :class="'text-' + prestador.certificado_vencido"></i>
                                </span>

                                <span v-else-if="prestador.tem_certificado" class="mr-2" title="Possui certificado digital.">
                                    <i class="fa-solid fa-certificate text-secondary"></i>
                                </span>

                                <span class="badge badge-secondary" title="Id do Prestador">#{{ prestador.id_pessoa }}</span>
                            </div>
                        </div>
                    </span>
                </li>
            </div>

            <pre v-if="1 == 0 && !em_edicao">{{ lista_dados }}</pre>

        </div>

		<!-- Formulário -->
		<div v-if="em_edicao">
            <az-empty-state v-if="!item" />

			<div class="card" style="padding: 0px;" v-else>

                <div class="card-header lead bg-success text-white" v-if="!item.id_pessoa">
                    Novo
                </div>

				<div class="card-body">
                    <div class="row">
                        <div class="col col-12 col-md-6">
                            <div class="row">
                                <div class="col col-12">
                                    <az-input label="Nome Completo" :validate="validate" required v-model="item.pessoa.st_nome" :rules="['nome']"/>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col col-12">
                                    <az-input label="Nome para Exibição" :validate="validate" required v-model="item.st_nome_exibicao" :rules="['nome']"/>
                                </div>
                            </div>
                            <div class="row" v-if="item.usuario">
                                <div class="col col-12">
                                    <az-input
                                        label="Login de Acesso"
                                        :edicao="false"
                                        icon="fas fa-user"
                                        :buttonIcon="true"
                                        buttonText="fas fa-user"
                                        @clickButton="$util.abrirUsuario(item.usuario)"
                                        v-model="item.usuario.st_login">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="$store.state.user.id_usuario == 1">
                                                <button class="btn btn-outline-secondary" type="button" @click="remover_link_usuario(item)" title="Remover link com o usuário.">
                                                    <i class="fa-solid fa-link-slash"></i>
                                                </button>
                                            </div>
                                        </template>
                                </az-input>
                                </div>
                            </div>
                        </div>
                        <div class="col col-12 col-md-3" v-if="item.id_pessoa" >
                            <az-single-image-loader
                                v-if="!setup"
                                titulo="Assinatura"
                                chave="ass"
                                :single="true"
                                :arquivo="item.imagem_assinatura"
                                :parms="{ model_type: 'medico', model_id: item.id_pessoa, cadastro_medico: true, tipo_especial: 'ass' }"
                                service="medicos">
                            </az-single-image-loader>
                        </div>

                        <div class="col col-12 col-md-3" v-if="item.id_pessoa">
                            <az-single-image-loader
                                titulo="Foto"
                                :single="true"
                                :arquivo="item.logo"
                                :parms="{ model_type: 'medico', model_id: item.id_pessoa, cadastro_medico: true, public: true }"
                                service="medicos"></az-single-image-loader>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-12 col-md-6">
                            <az-input label="Sexo" type="sexo" required :validate="validate" v-model="item.cadastro.ch_sexo"/>
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input label="Data de Nascimento" type="date" :validate="validate" v-model="item.cadastro.dt_nascimento" :rules="['nasc']" />
                        </div>
                        <div class="col col-12 col-md-3" v-if="item.pessoa">
                            <az-input label="Id Externo" :validate="validate" v-model="item.pessoa.st_id_externo" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-12" :class="setup ? 'col-md-6' : 'col-md-3'">
                            <az-input label="CPF" type="cpf" required :validate="validate" v-model="item.cadastro.st_cpf" />
                        </div>

                        <template v-if="!setup">
                            <div class="col col-12 col-md-3">
                                <az-input label="RG" type="rg" :validate="validate" v-model="item.cadastro.st_rg" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input label="Cartão Nacional de Saúde (CNS)" type="cns" :validate="validate" v-model="item.st_cns">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <a class="btn btn-outline-secondary" type="button" href="http://cnes.datasus.gov.br/pages/profissionais/consulta.jsp" target="_blank">
                                                <i class="fas fa-search"></i>
                                            </a>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </template>

                        <div class="col col-12" :class="setup ? 'col-md-6' : 'col-md-3'">
                            <az-input
                                label="e-mail"
                                type="email"
                                :validate="validate"
                                :required2="( !item.id_pessoa || !item.usuario ) && ( item.senha_por_email )"
                                v-model="item.cadastro.st_email" />
                        </div>
                    </div>

                    <!-- Dados de Acesso -->
                    <div v-if="!item.id_pessoa || !item.usuario">
                        <az-sub-title title="Dados de Acesso" class="mt-3" :big="true" />
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input label="Login" required :validate="validate" v-model="item.login" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input label="Definir Senha por e-mail"
                                    type="checkbox"
                                    :validate="validate"
                                    v-model="item.senha_por_email" />
                            </div>
                            <div class="col col-12 col-md-3" v-if="!item.senha_por_email">
                                <az-input
                                    icon="fas fa-eye"
                                    :buttonIcon="true"
                                    buttonText="fas fa-eye"
                                    @clickButton="item.show_password = !item.show_password"
                                    :type="item.show_password ? 'text' : 'password'"
                                    label="Senha"
                                    required
                                    :validate="validate"
                                    v-model="item.senha" />
                            </div>
                        </div>
                    </div>

                    <!-- Endereço -->
                    <template v-if="!setup">
                        <az-sub-title title="Endereço" class="mt-3" :big="true" />
                        <cadastro-endereco v-model="item.cadastro.endereco" :validate="validate" />
                    </template>

                    <!-- Telefones -->
                    <template v-if="!setup">
                        <az-sub-title class="mt-3" title="Telefones" :big="true" />
                        <cadastro-telefones v-model="item.cadastro.telefone_cadastros" :validate="validate" />
                    </template>

                    <!-- Dados Profissionais -->
                    <az-sub-title class="mt-3" title="Dados Profissionais" :big="true" />
                    <div class="row">

                        <div class="col col-12 col-md-3">
                            <AzInput label="Conselho"
                                type="select"
                                optionsMode="aql"
                                service="conselhos.index"
                                optionsData="id_conselho"
                                optionsDisplay="st_sigla"
                                v-model="item.id_conselho"
                                required
                                :validate="validate" />
                        </div>

                        <div class="col col-12 col-md-3">
                            <AzInput label="UF"
                                type="select"
                                optionsMode="aql"
                                service="estados.index"
                                optionsData="id_estado"
                                optionsDisplay="st_estado"
                                v-model="item.id_estado_conselho"
                                required
                                :validate="validate" />
                        </div>

                        <div class="col col-12 col-md-3">
                            <AzInput
                                label="Número do Conselho"
                                type="mask"
                                mask="##########"
                                v-model="item.in_numero_conselho"
                                required
                                :validate="validate" />
                        </div>

                        <div class="col col-12 col-md-3" v-if="item.id_conselho == 9">
                            <AzInput
                                label="Região"
                                type="number"
                                v-model="item.in_numero_regiao_conselho"
                                :validate="validate" />
                        </div>

                    </div>

                    <div class="row">
                        <div class="col col-12">
                            <az-input
                                label="RQE"
                                v-model="item.st_rqe"
                                :validate="validate" />
                        </div>
                    </div>

                    <!-- Outros Conselhos -->
                    <div v-for="(medico_conselho, imx) in item.conselhos" :key="imx">
                        <div v-if="!medico_conselho.excluido" class="row">
                            <div class="col col-12 col-md-3">
                                <AzInput label="Conselho"
                                    type="select"
                                    optionsMode="aql"
                                    service="conselhos.index"
                                    optionsData="id_conselho"
                                    optionsDisplay="st_sigla"
                                    v-model="medico_conselho.id_conselho"
                                    required
                                    :validate="validate">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <button type="button" class="btn btn-outline-danger" @click="medico_conselho.excluido = true">
                                                <i class="fa-solid fa-minus"></i>
                                            </button>
                                        </div>
                                    </template>
                                </AzInput>
                            </div>

                            <div class="col col-12 col-md-3">
                                <AzInput label="UF"
                                    type="select"
                                    optionsMode="aql"
                                    service="estados.index"
                                    optionsData="id_estado"
                                    optionsDisplay="st_estado"
                                    v-model="medico_conselho.id_estado"
                                    required
                                    :validate="validate" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <AzInput
                                    label="Número do Conselho"
                                    type="mask"
                                    mask="##########"
                                    v-model="medico_conselho.in_numero_conselho"
                                    required
                                    :validate="validate" />
                            </div>

                            <div class="col col-12 col-md-3" v-if="medico_conselho.id_conselho == 9">
                                <AzInput
                                    label="Região"
                                    type="number"
                                    v-model="medico_conselho.in_numero_regiao_conselho"
                                    :validate="validate" />
                            </div>
                        </div>

                        <div v-if="!medico_conselho.excluido" class="row">
                            <div class="col col-12">
                                <az-input
                                    :compact="true"
                                    label="RQE"
                                    placeholder="RQE..."
                                    v-model="medico_conselho.st_rqe"
                                    :validate="validate" />
                            </div>
                        </div>

                        <div v-if="!medico_conselho.excluido" class="row">
                            <div class="col col-12">
                                <az-input
                                    placeholder="Preencha esse campo se desejar ter um texto de assinatura personalizado."
                                    type="textarea"
                                    rows="3"
                                    v-model="medico_conselho.st_assinatura"
                                    :validate="validate" />
                            </div>
                        </div>
                    </div>

                    <button type="button" class="btn btn-outline-primary btn-sm mt-2" @click="incluir_conselho()">
                        <i class="fa-solid fa-plus"></i>
                    </button>

                    <!-- Especialidades -->
                    <az-sub-title class="mt-3" title="Especialidades" :big="true" />
                    <especialidades-vinculadas :validate="validate" :setup="setup" v-model="item.medico_especialidade" />

                    <az-input
                        v-if="!setup"
                        label="Texto de Subespecialidade"
                        placeholder="Ex.: Catarata, Joelho, Coluna..."
                        v-model="item.st_sub_especialidade"
                        :maxlength="255"
                        :validate="validate" />

                    <az-input
                        class="my-2"
                        v-if="!setup && tem_espec_anest"
                        type="checkbox-group"
                        label="Atua como anestesista"
                        v-model="item.medico_unidade.fl_anestesista"
                        :validate="validate"  />

                    <!-- Dados Bancários -->
                    <template v-if="!setup && item.cadastro && item.cadastro.dados_bancarios">
                        <az-sub-title class="mt-3" title="Dados Bancários" :big="true" />
                        <dados-bancarios v-model="item.cadastro.dados_bancarios" :validate="validate"/>
                    </template>

                    <template v-if="tem_fornecedores && !setup">
                        <az-input
                            placeholder="Selecione a PJ do prestador (se houver) do cadastro de fornecedores..."
                            label="PJ"
                            :validate="validate"
                            type="autocomplete"
                            optionsMode="aql"
                            service="fornecedores.index"
                            optionsData="id_fornecedor"
                            optionsDisplay="search"
                            v-model="item.id_fornecedor" />
                    </template>

                    <!-- Regras de Rateio -->
                    <div v-if="item.id_pessoa && !setup">
                        <az-sub-title class="mt-3" title="Regras de Repasse" :big="true">
                            <div class="d-flex">
                                <div class="custom-control custom-switch mr-3">
                                    <input type="checkbox" class="custom-control-input" id="exibir-ativos"
                                        v-model="exibir_repasse_ativos" @change="refresh_repasse_ativos()">
                                    <label class="custom-control-label" for="exibir-ativos">Repasses Ativos</label>
                                </div>
                                <div data-toggle="tooltip" data-placement="top" title="Regras em ordem da mais específica para a mais genérica.">
                                    <i class="fas fa-sort-amount-down-alt mr-2"></i>
                                </div>
                            </div>
                        </az-sub-title>

                        <div class="list-group mb-3" v-if="item.rateio_medicos && item.rateio_medicos.length">
                            <draggable v-model="lista_rateios" @start="drag=true" @end="drag=false; atualizarOrdem();" ghost-class="primary">

                                <li class="list-group-item d-flex justify-content-between"
                                    v-for="(item_rateio, irm) in lista_rateios" :key="irm">
                                    <span>
                                        <a href="#" @click.prevent="editarRateio(item_rateio)" class="h5 card-link mb-0 mr-3">
                                            {{ item_rateio.search }}
                                        </a>
                                        <span class="badge badge-secondary ml-2">#{{ item_rateio.id_rateio_medico }}</span>

                                        <span class="badge ml-3" :class="'badge-' + ( item_rateio.ch_tipo_repasse == 'R' ? 'success' : ( item_rateio.ch_tipo_repasse == 'F' ? 'primary' : 'secondary' ) )"
                                            :title="( item_rateio.ch_tipo_repasse == 'R' ? 'Recebido' : ( item_rateio.ch_tipo_repasse == 'F' ? 'Faturado/Pago' : 'Produzido' ) )">
                                            {{ item_rateio.ch_tipo_repasse }}
                                        </span>
                                    </span>
                                    <span>
                                        <div class="custom-control custom-switch" v-show="!exibir_repasse_ativos">
                                            <input type="checkbox" class="custom-control-input" :id="'ativo-rat-' + irm"
                                                v-model="item_rateio.fl_ativo" @change="toggle_rateio(item_rateio)">
                                            <label class="custom-control-label" :for="'ativo-rat-' + irm"></label>
                                        </div>
                                        <div v-if="exibir_repasse_ativos">
                                            {{ item_rateio.info_rateio }}

                                            <span class="badge badge-secondary ml-2" title="Número de Ordem das Regras.">{{ item_rateio.in_regra_ordem }}</span>
                                        </div>
                                    </span>
                                </li>

                            </draggable>
                        </div>

                        <p class="mb-3" v-else>Nenhuma regra de repasse registrada.</p>

                        <button type="button" class="btn btn-outline-secondary btn-sm" @click="incluirRateio ()">
                            <i class="fas fa-plus mr-2"></i>
                            Incluir Regra
                        </button>

                        <div class="row mt-3">
                            <div class="col col-12">
                                <az-input
                                    label="E-mails de destino do repasse (separados por ponto-e-vírgula)"
                                    placeholder="Próprio e-mail do médico..."
                                    v-model="item.medico_unidade.st_email_repasse" />
                            </div>
                        </div>

                    </div>

                    <!-- Restrição para Paicentes -->
                    <template v-if="!setup">
                        <az-sub-title class="mt-3" title="Restrição de Pacientes" :big="true" />
                        <div class="row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="number"
                                    label="Idade Mínima"
                                    placeholder="0"
                                    v-model="item.medico_unidade.in_paciente_idade_minima" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="number"
                                    label="Idade Máxima"
                                    placeholder="999"
                                    v-model="item.medico_unidade.in_paciente_idade_maxima" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="sexo"
                                    placeholder="Qualquer"
                                    label="Sexo do Paciente"
                                    v-model="item.medico_unidade.ch_paciente_sexo" />
                            </div>
                        </div>
                    </template>

                    <!-- Assinatura -->
                    <template v-if="!setup">
                        <az-sub-title class="mt-3" title="Assinatura" :big="true" />
                        <az-input
                            placeholder="Preencha esse campo se desejar ter um texto de assinatura personalizado."
                            type="textarea"
                            rows="4"
                            v-model="item.st_assinatura"
                            :validate="validate" />
                    </template>

                    <!-- Instruções -->
                    <template v-if="item.medico_unidade && !setup">
                        <az-sub-title class="mt-3" title="Instruções" :big="true" />

                        <az-input
                            type="textarea"
                            rows="3"
                            v-model="item.medico_unidade.st_instrucao"
                            placeholder="Instruções Internas..."
                            :validate="validate" />

                        <az-input
                            label="Agenda On-Line / Paciente"
                            type="textarea"
                            rows="3"
                            placeholder="Instruções para o paciente..."
                            v-model="item.medico_unidade.st_instrucao_agenda_online"
                            :validate="validate" />

                        <div v-if="1 == 0">
                            <vue-markdown />
                        </div>

                        <!-- Outras Configurações -->
                        <az-sub-title class="mt-3" title="Outras Configurações" :big="true" />
                        <az-input
                            label="Prazo de Revisão de Consutlas"
                            placeholder="Definido na operadora..."
                            type="number"
                            :validate="validate"
                            v-model="item.medico_unidade.in_prazo_revisao" />

                        <p class="alert alert-info">
                            No validação do prazo de revisão na agenda, será considerado o menor prazo entre o prazo definido para o prestador e o prazo definido para o convênio.
                        </p>

                        <!-- Google calendar -->
                        <az-input label="Id do Calendário do Google"
                            :validate="validate"
                            v-model="item.cadastro.st_google_calendar"
                            :edicao="!item.cadastro.fl_google_calendar"
                            v-if="item.google_calendar"
                        >
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn" :class="item.cadastro.fl_google_calendar ? 'btn-outline-success' : 'btn-outline-primary'" type="button" @click="ativar_google_calendar ()">
                                        <i class="fas mx-2" :class="item.cadastro.fl_google_calendar ? 'fa-calendar-times' : 'fa-calendar-check'"></i>
                                        {{item.cadastro.fl_google_calendar ? '' : 'Ativar'}}
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <!-- Memed -->
                        <az-input
                            label="Status Integração Memed"
                            type="select"
                            :validate="validate"
                            v-model="item.st_memed_status"
                            :edicao="false"
                            :optionsList="[{ id: null, search: 'Não cadastrado' }, { id: 'E', search: 'Em análise' }, { id: 'A', search: 'Ativo' }, { id: 'I', search: 'Inativo' }]"
                            optionsData="id"
                            v-if="item.integracao_memed"
                        >
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <az-submit color="outline-primary" @click="integrar_memed ('C')" v-if="item.st_memed_status == null || item.st_memed_status == ''">
                                        <i class="fas fa-medkit mx-2" ></i>
                                        Ativar
                                    </az-submit>
                                    <az-submit color="outline-success" @click="integrar_memed ('U')" v-if="item.st_memed_status == 'A'">
                                        <i class="fas fa-medkit mx-2" ></i>
                                        Atualizar
                                    </az-submit>
                                    <az-submit color="outline-warning" @click="integrar_memed ('S')" v-if="item.st_memed_status == 'I' || item.st_memed_status == 'E'">
                                        <i class="fas fa-medkit mx-2" ></i>
                                        Consultar status
                                    </az-submit>
                                    <az-submit color="outline-danger" @click="integrar_memed ('D')" v-if="item.st_memed_status == 'A' || item.st_memed_status == 'I' || item.st_memed_status == 'E'">
                                        <i class="fas fa-medkit mx-2" ></i>
                                        Desativar
                                    </az-submit>
                                </div>
                            </template>
                        </az-input>

                        <!-- Classificação -->
                        <az-sub-title class="mt-3" title="Classificação" :big="true" />

                        <div class="row mb-3">
                            <div class="col col-12">

                                <multiselect
                                    v-model="item.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação criada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <!-- Campos Customizados -->
                        <div v-if="item.campos_customizados" class="row">
                            <div class="col col-12">
                                <az-sub-title :title="item.campos_customizados.st_titulo" :big="true" />
                                <formulario
                                    :gutters="true"
                                    :validate="validate"
                                    v-model="item.campos_customizados.js_campos"
                                    :saved="true"
                                    mode="fixed"
                                    :config="true" />
                            </div>
                        </div>

                    </template>

				</div>

                <pre v-if="1 == 0">{{ item }}</pre>

				<!-- Botões de Atualização -->

				<nav class="navbar fixed-bottom navbar-light bg-light pb-3 d-flex justify-content_between">
                    <div>
                        <az-submit @click="atualizar ()" class="mr-2">{{ item.id_pessoa ? 'Atualizar' : 'Incluir' }}</az-submit>
                        <button class="btn btn-secondary mr-2" @click="fechar ()">Fechar</button>
                        <button class="btn btn-outline-secondary mr-2" @click="$util.logAudit('medico', item.id_pessoa)"
                            v-if="item.id_pessoa && !setup">
                            Log
                        </button>
                        <button class="btn btn-outline-primary mr-2" @click="addNewItem ()" v-if="item.id_pessoa">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>
                    </div>
                    <div class="d-flex" v-if="item.id_pessoa && !setup">

                        <template v-if="lista_enquetes && lista_enquetes.length">
                            <a href="#" @click.prevent="preencher_enquente(item)" 
                                class="btn btn-sm mr-1" 
                                :class="item.enquetes_aplicadas_count > 0 ? 'btn-dark' : 'btn-outline-dark'"
                                title="Avaliação de Prestador">
                                <i class="fa-solid fa-clipboard-check"></i>
                                <span v-if="item.enquetes_aplicadas_count" class="badge badge-light ml-1">
                                    {{ item.enquetes_aplicadas_count }}
                                </span>
                            </a>
                        </template>

                        <button class="btn btn-outline-primary btn-sm mr-2" @click="abrir_anexos ()">
                            <i class="fa-solid fa-paperclip"></i>
                            <span class="badge badge-primary ml-1" v-if="item.medico_unidade && item.medico_unidade.arquivos && item.medico_unidade.arquivos.length">
                                {{ item.medico_unidade.arquivos.length }}
                            </span>
                        </button>
                        <button class="btn btn-outline-primary btn-sm mr-2" @click="abrirAssinatura ()" v-if="1 == 0" title="Assinatura">
                            <i class="fas fa-signature mr-2"></i>
                            <span class="d-none d-lg-block">
                                Assinatura
                            </span>
                        </button>

                        <button class="btn btn-outline-primary btn-sm mr-2 d-block d-lg-none" @click="abrirOperadoras ()">
                            <i class="far fa-credit-card"></i>
                        </button>

                        <button class="btn btn-outline-primary btn-sm mr-2 d-none d-lg-block" @click="abrirOperadoras ()">
                            <i class="far fa-credit-card mr-2"></i>
                            Operadoras
                            <span class="badge badge-primary ml-1" v-if="item.medico_operadora_count">
                                {{ item.medico_operadora_count }}
                            </span>
                            <span class="text-warning ml-1" v-else>
                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            </span>
                        </button>

                        <!-- Procedimentos -->

                        <button class="btn btn-outline-primary btn-sm mr-2 d-block d-lg-none" @click="abrirProcedimentos ()">
                            <i class="fas fa-play"></i>
                        </button>
                        
                        <button class="btn btn-outline-primary btn-sm mr-2 d-none d-lg-block" @click="abrirProcedimentos ()">
                            <i class="fas fa-play mr-2"></i>
                            Procedimentos
                        </button>

                        <!-- Agenda -->

                        <button class="btn btn-outline-primary btn-sm mr-2 d-block d-lg-none" @click="abrirAgenda ()">
                            <i class="fas fa-calendar"></i>
                        </button>

                        <button class="btn btn-outline-primary btn-sm mr-2 d-none d-lg-block" @click="abrirAgenda ()">
                            <i class="fas fa-calendar mr-2"></i>
                            Agendas
                        </button>
                    </div>
				</nav>

			</div>

			<br><br>
		</div>

        <!-- Modal Operadoras -->
        <div class="modal fade" id="operadorasModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="operadoras_todas">
                    <div class="modal-header">
                        <h5 class="modal-title">Operadoras Habilitadas</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="d-flex flex-column mb-3">
                            <az-input
                                type="button-group"
                                :optionsList="[{ id: 'lista', search: 'Ativas' }, { id: 'edicao', search: 'Todas' }]"
                                v-model="viewOper" />

                            <div v-if="viewOper == 'lista'">
                                <ul class="list-group mt-3" v-if="operadoras_todas.filter(item => item.medico_operadora.fl_ativo).length">
                                    <li class="list-group-item" v-for="(oper, ip) in operadoras_todas.filter(item => item.medico_operadora.fl_ativo)" :key="ip">
                                        <a href="#" class="card-link" @click.prevent="$util.abrirOperadora(oper)">
                                            {{ oper.search }}
                                        </a>
                                    </li>
                                </ul>
                                <div class="mt-3" v-else>
                                    <az-empty-state msg="Nenhuma operadora habilitada" icon="far fa-credit-card" />
                                </div>
                            </div>

                            <!-- Edição -->
                            <div v-else>
                                <div v-if="operadoras_todas.length" class="mt-3">
                                    <az-input
                                        type="checkbox-group"
                                        label="TODOS"
                                        v-model="marcarTodosOper"
                                        @click="marcar_operadoras ()" />

                                    <div v-for="(oper, ip) in operadoras_todas" :key="ip">
                                        <az-input
                                            type="checkbox-group"
                                            :label="oper.search"
                                            v-model="oper.medico_operadora.fl_ativo"
                                            @input="oper.medico_operadora.fl_ativo ? '' : ( marcarTodosOper = false )" />
                                    </div>

                                </div>

                                <div v-else>
                                    <az-empty-state msg="Nenhuma operadora disponível" icon="fa fa-play" />
                                </div>

                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="viewOper == 'edicao'" @click="atualizar_operadoras()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Procedimentos -->
        <div class="modal fade" id="procedimentosModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Procedimentos Habilitados</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <div v-if="!procedimentos || !procedimentos.length">
                        <az-empty-state msg="Nenhum procedimento identificado" />
                    </div>

                    <div v-else>

                        <p class="alert alert-danger" v-if="item && item.medico_especialidade && !item.medico_especialidade.length">
                            Nenhuma especialidade cadastrada para o prestador.
                        </p>

                        <div class="d-flex flex-column mb-3">
                            <az-input
                                type="button-group"
                                :optionsList="[{ id: 'lista', search: 'Ativos' }, { id: 'edicao', search: 'Todos' }]"
                                v-model="viewProc" />
                        </div>

                        <az-input
                            type="select"
                            icon="fa fa-filter"
                            placeholder="Todas as especialidades..."
                            :optionsList="lista_proc_especialidades"
                            optionsMode="json"
                            optionsData="id_especialidade"
                            v-model="filtroproc.id_especialidade" />

                        <az-input
                            icon="fa fa-search"
                            placeholder="Pesquisar..."
                            v-model="filtroproc.search" />

                        <div v-if="viewProc == 'edicao'">

                            <div v-if="procedimentos_todos.length">

                                <button type="button" class="btn btn-outline-primary btn-sm mt-2 mb-1"
                                    @click="marcar_procedimentos ()">
                                    Todos
                                </button>

                                <template v-for="(proc, ip) in procedimentos_todos">
                                    <div v-if="valid_regex(proc) && ( !filtroproc.id_especialidade || proc.id_especialidade == filtroproc.id_especialidade )" :key="ip">
                                        <az-input
                                            type="checkbox-group"
                                            :label="proc.search"
                                            v-model="proc.medico_procedimento_unidades.fl_ativo"
                                            @input="proc.medico_procedimento_unidades.fl_ativo ? '' : ( marcarTodosProc = false )">
                                            <template v-slot:buttonposcb>
                                                <div class="input-group-append">
                                                    <span class="input-group-text">
                                                        <small>
                                                            {{ proc.especialidade.search }}
                                                        </small>
                                                    </span>
                                                    <span class="input-group-text">
                                                        <small>
                                                            #{{ proc.id_procedimento }}
                                                        </small>
                                                    </span>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </template>

                            </div>

                            <div v-else>
                                <az-empty-state msg="Nenhum procedimento disponível" icon="fa fa-play" />
                            </div>

                        </div>

                        <div v-else>

                            <ul class="list-group" v-if="procedimentos_todos.filter(item => item.medico_procedimento_unidades.fl_ativo).length">
                                <template v-for="(proc, ip) in procedimentos_todos.filter(item => item.medico_procedimento_unidades.fl_ativo)">
                                    <li class="list-group-item"  :key="ip" v-if="valid_regex(proc) && ( !filtroproc.id_especialidade || proc.id_especialidade == filtroproc.id_especialidade )">
                                        <a href="#" class="card-link" @click.prevent="abrirProcedimento(proc)">
                                            {{ proc.search }}
                                        </a>
                                    </li>
                                </template>
                            </ul>

                            <div v-else>
                                <az-empty-state msg="Nenhum procedimento habilitado" icon="fa fa-play" />
                            </div>

                        </div>

                    </div>

                    <pre v-if="1 == 0">{{ procedimentos_todos }}</pre>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    <az-submit v-if="viewProc == 'edicao'" @click="atualizar_procedimentos()">Atualizar</az-submit>
                </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="memedDebugModal" tabindex="-1" role="dialog" aria-labelledby="memedDebugModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="memedDebugModalTitle">Debug da Integração Memed</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-lg-6 mb-3 mb-lg-0">
                                <h6>Payload</h6>
                                <pre class="border rounded bg-light p-2 mb-0" style="min-height: 320px; max-height: 60vh; overflow: auto;">{{ memed_debug_payload }}</pre>
                            </div>
                            <div class="col col-12 col-lg-6">
                                <h6>Body/Data</h6>
                                <pre class="border rounded bg-light p-2 mb-0" style="min-height: 320px; max-height: 60vh; overflow: auto;">{{ memed_debug_data }}</pre>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="carregarAssinaturaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" v-if="1 == 0">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Assinatura</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <p>Carregar Certificado Digital A1, para permitir assinatura de documentos do prontuário. (Arquivo PFX)</p>

                        <az-single-image-loader
                            chave="pfx"
                            :titulo="item.tem_certificado ? 'Atualizar Certificado' : 'Carregar Certificado'"
                            :single="true"
                            :parms="{ model_type: 'medico', model_id: item.id_pessoa, cadastro_medico: true, tipo_especial: 'certificado' }"
                            extension="pfx"
                            mimetype="application/x-pkcs12"
                            service="medicos" />

                        <button class="btn btn-outline-primary" @click="solicitar_certificado = true" v-if="!solicitar_certificado">
                            Verificar certificado
                        </button>

                        <template v-else>

                            <az-input
                                label="Chave"
                                required
                                v-model="chave_certificado"
                                icon="fa fa-minus"
                                :buttonIcon="true"
                                buttonText="fa fa-minus"
                                @clickButton="solicitar_certificado = false"
                                type="password"
                                :iconEnd="chave_certificado ? { color: 'outline-success', icon: 'fa fa-check' } : null"
                                @clickButtonEnd="verificarCertificado ()" />

                            <template v-if="$store.state.loading">
                                <div class="spinner-border mt-2" role="status">
                                <span class="sr-only">Loading...</span>
                                </div>
                            </template>
                            <template v-else-if="dados_certificado">
                                <pre class="mt-2">{{ dados_certificado.subject }}</pre>
                                <pre>Validade: {{ dados_certificado.validTo}}</pre>
                            </template>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <edicao-rateio-medico ref="editarrateio" @refresh="refresh_rateios()" />

        <enquete ref="enquete" @refresh="load()" />

        <!-- Envio de Arquivo -->
        <template v-if="acao_anexar && item && item.medico_unidade && item.medico_unidade.arquivos">
            <az-file-upload
                ref="upload"
                @refresh="carregar_arquivos()"
                :tem_validade="true"
                :multiple="true"
                :arquivos="item.medico_unidade.arquivos"
                :parms="{ model_type: 'medicoUnidade', model_id: item.medico_unidade.id_medico_unidade }" />
        </template>

	</div>
</template>

<script>

import _ from 'lodash';
import $ from 'jquery';
import draggable from "vuedraggable";

import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import CadastroEndereco from '../../shared/CadastroEndereco.vue';
import CadastroTelefones from '../../shared/CadastroTelefones.vue';
import EspecialidadesVinculadas from '../shared/EspecialidadesVinculadas.vue';
import DadosBancarios from '../shared/DadosBancarios.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSingleImageLoader from '../../util/AzSingleImageLoader.vue';
import VueMarkdown from 'vue-markdown'
import EdicaoRateioMedico from '../shared/EdicaoRateioMedico.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import Importacao from '../shared/Importacao.vue';
import Multiselect from 'vue-multiselect';
import Formulario from '../../modulos/consultorio/Formulario.vue';
import Enquete from '../../shared/Enquete.vue';

export default {
    data () {
        return {
            filters: {},
            dialogVisible: false,
            selectedItem: null,
            item: null,
            geral: {},
            model: "",
            lista: { data: null },
            campos: [],
            campos_edicao: [],
            formErrors: [],
            edicao: [],
            chave: "",
            loading: true,
            last_page: 0,
            em_edicao: false,
            filhos: [],
            dados: {},
            reloading: false,
            search: "",
            firstLoadDone: false,
            breadcrumb: [],
            selectOptions: null,
            especialidade: "",
            validate: false,
            procedimentos: null,
            rateio: null,
            validateRateio: false,
            rateioNovaOperadora: null,

            procedimentos_todos: null,
            marcarTodosProc: false,
            viewProc: 'lista',

            operadoras_todas: null,
            marcarTodosOper: false,
            viewOper: 'lista',

            solicitar_certificado: false,
            chave_certificado: "",
            dados_certificado: null,

            exibir_repasse_ativos: true,

            lista_rateios: [],

            viewMode: 'A',
            tem_fornecedores: false,

            acao_anexar: false,
            options_classes: [],

            selecionado: null, 

            filtroproc: {
                id_especialidade: "",
                search: "",
            },

            ver_vencidos: false, 
            lista_enquetes: [], 

            filtro_certificado: "", 

            memed_debug_payload: "",
            memed_debug_data: "",
        }
    },

    watch: {
        '$store.state.unidade': function () {
            this.load();

            if ( this.item )
                this.editar (this.item);
        },

        id_medico: function () {
            if ( !this.id_medico && this.em_edicao ) {
                this.fechar();
            }
        },

    },

    components: {
        ConfigMainTitle,
        AzInput,
        AzSubTitle,
        CadastroEndereco,
        CadastroTelefones,
        EspecialidadesVinculadas,
        DadosBancarios,
        AzSubmit,
        AzEmptyState,
        AzSingleImageLoader,
        draggable,
        VueMarkdown,
        EdicaoRateioMedico,
        AzFileUpload,
        Importacao,
        Multiselect,
        Formulario, 
        Enquete
    },

    props: ['title','parentKey', 'parentModel', 'id_medico', 'link', 'setup'],

    computed: {
        anexos_vencidos: function () { 
            let hoje = this.$util.hoje();
            return this.lista_dados.flatMap(item => ( item.medico_unidade && item.medico_unidade.arquivos ) ? item.medico_unidade.arquivos.filter(item => item.dt_validade && item.dt_validade < hoje) : []);
        }, 

        tem_espec_anest: function () {
            if ( !this.item || !this.item.medico_especialidade ) {
                return false;
            }

            return this.item.medico_especialidade.find(item => item.id_especialidade == 18 && !item.excluido) ? true : false;
        },

        lista_proc_especialidades: function () {
            return _.sortBy(
                _.uniqBy(
                    this.procedimentos_todos.map(proc => proc.especialidade),
                    'id_especialidade'
                ),
                'search'
            );
        },

        lista_outros_participantes: function () {
            if ( !this.rateio || !this.rateio.outros_participantes )
                return [];

            return this.rateio.outros_participantes.filter(item => item.fl_ativo);
        },

        lista_rateios2 () {
            if ( !this.item )
                return [];

            return this.item.rateio_medicos.filter(item => item.fl_ativo || !this.exibir_repasse_ativos);
        },

        lista_childs_in () {
            if ( !this.campos.data.list_childs )
                return [];

            return _.filter(this.campos.data.list_childs, (item) => {
                        return item.mode == 'card';
                    });
        },
        lista_childs_tab () {
            if ( !this.campos.data.list_childs )
                return [];

            return _.filter(this.campos.data.list_childs, (item) => {
                        return item.mode != 'card';
                    });
        },
        lista_campos () {
            return this.campos.data.list_fields.filter((item) => {
                            return !item['hide'];
                        });
        },
        lista_dados () {
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            let hoje = this.$util.hoje();

            if ( this.lista && this.lista.data ) {
                return this.lista.data.filter(item => this.viewMode == 'T' || (item.medico_unidade && item.medico_unidade.fl_ativo))
                    .filter(item => {
                        return (
                            !this.especialidade || item.medico_especialidade.find(i => {
                                return i.id_especialidade == this.especialidade.id_especialidade;
                            })
                        ) && (
                            !this.search || reg.test(JSON.stringify(item))
                        )
                    })
                    .filter(item => !this.ver_vencidos || ( item.medico_unidade && item.medico_unidade.arquivos.find(arq => arq.dt_validade && arq.dt_validade < hoje)));
            }

            //return this.lista.data.data ? this.lista.data.data : [];
            return this.lista.data ? this.lista.data : [];
        }
    },
    methods: {
        cor_validade_certificado (validade) { 
            if ( validade < this.$util.hoje() ) { 
                return 'text-danger';
            } else if ( this.$util.getDataDias(30) > validade ) { 
                return 'text-warning';
            } else { 
                return 'text-success';
            }
        },

        incluir_conselho () { 
            this.item.conselhos.push({
                id_medico_conselho: null, 
                id_medico: this.item.id_pessoa,
                id_conselho: this.item.id_conselho,
                id_estado: "",
                in_numero_conselho: "", 
                in_numero_regiao_conselho: "", 
                excluido: false, 
            });
        },

        remover_link_usuario (item) { 

            if ( !confirm('Confirma remover o link do prestador com o usuário?') ) { 
                return;
            }

            this.$util.atualizar (this, {
                service: 'medicos',
                func: 'remover_link_usuario',
                dados: { 
                    id_medico: item.id_pessoa 
                },
                callback: () => {
                    this.refresh ();
                },
            });

        },

        preencher_enquente(item) { 
            this.$refs.enquete.abrir(item, 'App\\azure\\medico', 'id_pessoa');
        },

        //

        onArrowDown () { 
            if ( this.selecionado === null ) {
                this.selecionado = 0;
            } else { 
                this.selecionado ++;
            }
		},

		onArrowUp () { 
			if ( this.selecionado > 0 ) { 
				this.selecionado --;
			}			
		},

		onEnter () { 
            if ( _.get(this.lista_dados, this.selecionado) ) { 
                this.editar(this.lista_dados[this.selecionado])
            }
        },

        fechar_e_incluir () {
            // this.fechar();
        },

        ativar_google_calendar() {
            if(this.item.cadastro.fl_google_calendar) {
                this.item.cadastro.fl_google_calendar = false;
                this.item.cadastro.st_google_calendar = '';
                return;
            }

            this.$util.atualizar (this, {
                service: 'medicos',
                func: 'ativar_google_calendar',
                dados: { st_google_calendar: this.item.cadastro.st_google_calendar },
                callback: (res) => {
                    if(res && res.status && res.status == 'OK') {
                        this.item.cadastro.fl_google_calendar = true;

                        this.$nextTick(() => {
                            this.$toast.add({
                                severity: "success",
                                summary: "Atenção",
                                detail: "Calendário do google configurado com sucesso",
                                life: 3000
                            });
                        });
                    }
                },
            });
        },

        integrar_memed(acao) {
            let cbos  = _.get(this.item, 'medico_especialidade.0.especialidade.st_codigo_cbo');
            
            this.$util.atualizar (this, {
                service: 'medicos',
                func: 'integrar_memed',
                dados: {
                    id_medico: this.item.id_pessoa,
                    cbos: cbos,
                    acao: acao
                },
                callback: (res) => {
                    console.log('memed', res);

                    this.exibir_debug_memed(res);

                    if(res && res.status) {
                        const msg = res.msg ? res.msg : "Erro na integração com o Memed";

                        this.$nextTick(() => {
                            this.$toast.add({
                                severity: res.status == "OK" ? "success" : "warn",
                                summary: "Atenção",
                                detail: msg,
                                life: 3000
                            });
                        });

                        this.refresh ();
                    }
                },
                error: (res) => {
                    console.log('memed erro', res);

                    this.exibir_debug_memed(res);
                },
            });
        },

        exibir_debug_memed(retorno) {
            const isDebugUser = _.get(this, '$store.state.user.id_usuario') == 1;
            if (!isDebugUser) {
                return false;
            }

            const candidatos = [
                retorno,
                _.get(retorno, 'data'),
                _.get(retorno, 'response.data.atualizar.data'),
                _.get(retorno, 'response.data.atualizar'),
                _.get(retorno, 'response.data'),
            ].filter(Boolean);

            const dados = candidatos.find(item => _.has(item, 'payload') && (_.has(item, 'body') || _.has(item, 'data')));

            if (!dados) {
                return false;
            }

            this.memed_debug_payload = this.formatar_json_debug_memed(dados.payload);
            this.memed_debug_data = this.formatar_json_debug_memed(_.has(dados, 'body') ? dados.body : dados.data);

            this.$nextTick(() => {
                $('#memedDebugModal').modal('show');
            });

            return true;
        },

        formatar_json_debug_memed(valor) {
            if (valor === null || typeof valor === 'undefined') {
                return '';
            }

            if (typeof valor === 'string') {
                try {
                    return JSON.stringify(JSON.parse(valor), null, 2);
                } catch (e) {
                    return valor;
                }
            }

            return JSON.stringify(valor, null, 2);
        },

        valid_regex (item) {
            if ( !this.filtroproc.search )
                return true;

            let reg = this.$util.getregex(this.filtroproc.search);
            return reg.test(item.search);
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        carregar_arquivos(abrir = false) {
            this.$store.commit('loading', true);

            this.$util.loadItem(this, {
                service: 'arquivos',
                func: 'links',
                parms: {
                    id: this.item.medico_unidade.id_medico_unidade,
                    type: 'medicoUnidade',
                }
            })
            .then(res => {
                this.item.medico_unidade.arquivos = res;

                if ( abrir ) {
                    this.$nextTick(() => {
                        this.$refs.upload.abrir();
                    });
                }
            })
            .finally(() => {
                this.$store.commit('loading', false);
            });
        },

        abrir_anexos () {
            this.acao_anexar = true;

            if ( this.item.medico_unidade.arquivos && this.item.medico_unidade.arquivos.length
                && !this.item.medico_unidade.arquivos.find(arq => arq.arquivo) ) {

                this.carregar_arquivos(true);
                return;

            }

            this.$nextTick(() => {
                this.$refs.upload.abrir();
            });
        },

        incluirParticipante (rateio) {
            rateio.outros_participantes.push({
                id_rateio_medico: null,
                id_unidade: 1,
                id_medico: "",
                fl_ativo: true,
                dc_porcentagem_medico: 0,
                dc_valor_medico: 0,
                in_regra_ordem: 1,
                ch_operadoras_lista: 'R',
                valor_fixo: false,
            });
        },

        refresh_rateios() {
            this.$util.loadItem(this, {
                service: 'medicos',
                func: 'show',
                parms: {
                    id: this.item.id_pessoa,
                    cadastro_medico: true,
                }
            })
            .then(res => {
                this.item.rateio_medicos = res.rateio_medicos;
                this.refresh_repasse_ativos();
            });
        },

        refresh_repasse_ativos() {
            if ( !this.item || !this.item.rateio_medicos )
                return [];

            this.lista_rateios = this.item.rateio_medicos.filter(item => item.fl_ativo || !this.exibir_repasse_ativos);
        },

        verificarCertificado () {

            this.$store.commit("loading", true);

            this.$util.loadItem(this, {
                service: 'medicos',
                func: 'dados_certificado',
                parms: {
                    id_medico: this.item.id_pessoa,
                    chave: this.chave_certificado,
                }
            })
            .then(res => {
                this.dados_certificado = res;
            })
            .finally(() => {
                this.$store.commit("loading", false);
            });

        },

        abrirAssinatura () {
            this.solicitar_certificado = false;
            this.chave_certificado = "";
            this.dados_certificado = null;

            $('#carregarAssinaturaModal').modal('show');
        },

        atualizarOrdem () {

            this.$util.atualizar(this, {
                service: 'rateio_medicos',
                func: 'ordem',
                dados: {
                    lista: this.lista_rateios
                },
                toast: true,
            });

        },

        atualizar_operadoras () {
            this.$util.atualizar (this, {
                service: 'operadoras',
                func: 'vincular_medico',
                dados: {
                    ...this.operadoras_todas,
                },
                modal: 'operadorasModal',
                callback: () => { 
                    this.refresh ();
                } 
            });
        },
        atualizar_procedimentos () {
            this.$util.atualizar (this, {
                service: 'procedimentos',
                func: 'vincular_medico',
                dados: {
                    ...this.procedimentos_todos,
                },
                modal: 'procedimentosModal',
            });
        },
        marcar_procedimentos () {
            let lista = this.procedimentos_todos.filter(proc => this.valid_regex(proc)
                && ( !this.filtroproc.id_especialidade || proc.id_especialidade == this.filtroproc.id_especialidade ));

            let marcar = lista.find(proc => !proc.medico_procedimento_unidades.fl_ativo);

            lista.forEach(element => {
                element.medico_procedimento_unidades.fl_ativo = ( marcar ? true : false );
            });

            /*
            this.procedimentos_todos.forEach(element => {
                element.medico_procedimento_unidades.fl_ativo = !this.marcarTodosProc;
            });
            */
        },

        marcar_operadoras () {
            this.operadoras_todas.forEach(element => {
                element.medico_operadora.fl_ativo = !this.marcarTodosOper;
            });
        },
        incluirRateio () {
            this.$refs.editarrateio.incluir(this.item.id_pessoa);

            /*
            let item = {
                id_medico: this.item.id_pessoa,
                dt_data_vigencia: this.$util.hoje (),
                fl_ativo: true,
                in_dias_para_pagamento: 30,
                rateio_medico_operadoras: [],
                ch_operadoras_lista: "T",
                outros_participantes: [],
            };

            this.editarRateio(item);
            */
        },
        editarRateio (item) {
            this.$refs.editarrateio.editar(item.id_rateio_medico);

            /*
            this.rateio = null;
            this.rateioNovaOperadora = null;
            this.validate = false;

            this.$nextTick (() => {
                this.rateio = _.cloneDeep(item);
                $('#rateioModal').modal('show');
            });
            */
        },
        adicionarRateioOperadora () {
            if ( this.rateioNovaOperadora ) {

                this.rateio.rateio_medico_operadoras.push({
                    id_rateio_medico_operadora: null,
                    id_rateio_medico: this.rateio.id_rateio_medico,
                    id_operadora: this.rateioNovaOperadora.id_operadora,
                    search: this.rateioNovaOperadora.search,
                    selecionado: true,
                });

                this.$nextTick (() => {
                    this.rateioNovaOperadora =  null;
                })

            }
        },
        atualizarRateio () {
            this.$util.atualizar (this, {
                service: 'rateio_medicos',
                dados: { ...this.rateio },
                modal: 'rateioModal',
                callback: () => {
                    this.$util.loadItem(this, {
                        service: 'medicos',
                        func: 'show',
                        parms: {
                            id: this.item.id_pessoa,
                            cadastro_medico: true,
                        }
                    })
                    .then(res => {
                        this.item.rateio_medicos = res.rateio_medicos;
                        this.refresh_repasse_ativos();
                    });
                },
            });
        },
        removerRateio () {
            this.$util.remover (this, {
                service: 'rateio_medicos',
                dados: { ...this.rateio },
                modal: 'rateioModal',
                reload: true,
                callback: this.refresh,
            });
        },
        toggle_rateio (item) {
            if ( item.id_rateio_medico ) {
                this.$util.toggle (this, {
                    service: 'rateio_medicos',
                    dados: { ...item },
                });
            }
        },
        refresh () {
            this.editar (this.item);
        },
        editar (item) {
            let reload = item.id_pessoa ? true : false;

            this.validate = false;

            if ( !this.id_medico && !this.setup ) {
                this.$router.replace({ name: 'c-prestadores', params: { id_medico: item.id_pessoa }});
            }

            if ( item.id_pessoa ) {

                if ( !this.em_edicao ) {
                    this.$store.commit('loading', true);
                    this.item = null;
                    this.em_edicao = true;
                }

                let query = { q: [
                    {
                        name: 'medicos.show',
                        id: 'editar',
                        parms: {
                            id: item.id_pessoa,
                            cadastro_medico: true,
                            foto: true,
                        }
                    },
                ]};

                this.axios.post('/aql', query)
                    .then(res => {

                        if ( res.data.editar.status == 200 ) {
                            let dados = res.data.editar.data;

                            this.lista_rateios = dados.rateio_medicos.filter(item => item.fl_ativo || !this.exibir_repasse_ativos);

                            if ( !dados.usuario ) {
                                dados.login = "";
                                dados.senha = "";
                                dados.senha_por_email = true;
                                dados.show_password = false;
                            }

                            if ( !dados.medico_unidade ) {
                                dados.medico_unidade = {};
                            }

                            if ( !dados.cadastro ) {
                                dados.cadastro = {
                                    dados_bancarios: null,
                                    endereco: {},
                                    telefone_cadastros: [],
                                };
                            }

                            if ( !dados.cadastro.dados_bancarios )
                                dados.cadastro.dados_bancarios = {
                                    id_cadastro: null,
                                    id_banco: null,
                                    in_agencia: null,
                                    in_conta: null,
                                    ch_digito_conta: null,
                                    st_observacoes: null,
                                };

                            this.item = dados;
                            this.em_edicao = true;

                            if ( this.item.search && !this.setup ) {
                                let bc = _.cloneDeep(this.breadcrumb);
                                bc.push({
                                    name: this.item.search,
                                    path: "/config/prestadores",
                                    route_name: "c-prestadores",
                                    params: {
                                        id_medico: this.item.id_pessoa
                                    }
                                });
                                this.$store.commit('setBreadcrumb', bc);
                            }

                            if ( !reload )
                                window.scrollTo(0,0);
                        }

                    })
                    .finally (() => {
                        this.$store.commit('loading', false);
                    });

            } else {

                this.item = _.cloneDeep(item);

                this.em_edicao = true;

                if ( this.item.search && !this.setup ) {
                    let bc = _.cloneDeep(this.breadcrumb);
                    bc.push({ name: 'Novo', path: "" });
                    this.$store.commit('setBreadcrumb', bc);
                }

                window.scrollTo(0,0);

            }

        },

        abrirAgenda () {

            this.$router.push({
                name: 'c-agendas',
                params: {
                    id_medico: this.item.id_pessoa,
                }
            });

        },

        abrirOperadoras () {

            this.viewOper = 'lista';

            this.$util.load(this, {
                service: 'operadoras',
                parms: {
                    id_medico: this.item.id_pessoa,
                    ativos: true,
                },
                loadTo: res => {
                    this.operadoras_todas = res.map(item => {
                        if ( !item.medico_operadora ) {
                            item.medico_operadora = {
                                id_medico_operadora: null,
                                id_medico: this.item.id_pessoa,
                                id_operadora: item.id_operadora,
                                fl_ativo: false,
                            }
                        }
                        return item;
                    });
                    $('#operadorasModal').modal('show');
                }
            });

        },

        abrirProcedimentos () {
            this.viewProc = 'lista';

            this.$store.commit('loading', true);

            this.procedimentos_todos = null;
            this.procedimentos = null;
            this.filtroproc.id_especialidade = "";
            this.filtroproc.search = "";

            $('#procedimentosModal').modal('show');

            let query = { q: [
                {
                    name: 'medico_unidades.index',
                    id: 'procedimentos',
                    parms: {
                        cadastro_agenda: true,
                        where: {
                            id_medico: this.item.id_pessoa,
                        }
                    }
                },
                {
                    name: 'procedimentos.index',
                    id: 'procedimentos_todos',
                    parms: {
                        id_medico: this.item.id_pessoa,
                        lista_cadastro: true,
                        prestadores: true,
                        ativos: true,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => {
                    if ( res.data.procedimentos_todos.status == 200 ) {
                        this.procedimentos_todos = res.data.procedimentos_todos.data.map(item => {
                            if ( !item.medico_procedimento_unidades ) {
                                item.medico_procedimento_unidades = {
                                    id_medico_procedimento_unidade: null,
                                    id_medico_unidade: this.item.medico_unidade.id_medico_unidade,
                                    id_procedimento: item.id_procedimento,
                                    fl_ativo: false,
                                    in_tempo_atendimento: 30,
                                };
                            }
                            return item;
                        });
                    }

                    if ( res.data.procedimentos.status == 200 ) {
                        this.procedimentos = res.data.procedimentos.data.sort ((a, b) => {
                            return a.procedimento.search > b.procedimento.search ? 1 : -1;
                        });
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });
        },
        abrirProcedimento (proc) {
            this.$util.abrirProcedimento(proc);

            /*
            $('#procedimentosModal').modal('hide');

            this.$router.push({
                name: 'c-procedimentos',
                params: {
                    id_procedimento: proc.id_procedimento,
                }
            });
            */
        },
        getData (item, field) {
            return _.get(item, field);
        },
        addNewItem () {
            this.editar ({
                id_pessoa: null,
                pessoa: {},
                cadastro: {
                    dados_bancarios: {},
                    endereco: {},
                    telefone_cadastros: [],
                },
                medico_especialidade: [],
                usuario: null,
                login: "",
                senha: "",
                senha_por_email: true,
                show_password: false,
                medico_unidade: {
                    st_instrucao: "",
                    in_prazo_revisao: 30,
                }
            });
        },
        saveForm () {
            this.$refs.cadForm.salvar ();
        },
        saveItem (item = null) {

            if ( item )
                this.item = item;

            this.reloading = true;

            let query = {
                    q: [
                        {
                            name: 'medicos.store',
                            parms: { ...this.item },
                            id: 'salvar'
                        }
                    ]
                };

            this.axios.post('aql', query)
                .then (res => {
                    if ( res.data.salvar && res.data.salvar.data && res.data.salvar.data.status_code > 400 ) {
                        let error = {
                                    response: {
                                        status: res.data.salvar.data.status_code,
                                        data: { errors: res.data.salvar.data.msg }
                                    }
                                };
                        this.handleError(error);
                    } else {
                        this.load();
                        if ( $("#cadastroModal") ) {
                            $("#cadastroModal").modal('hide');
                        }
                    }
                })
                .catch (() => {
                    this.loading = false;
                    this.reloading = false;
                });
        },
        deleteItem () {

            this.reloading = true;

            let query = {
                            q: [
                                {
                                    name: 'medicos.destroy',
                                    parms: { ...this.item },
                                }
                            ]
                        };

            this.axios.post('aql', query)
                .then (() => {
                    this.dialogVisible = false;
                    this.load();
                })
                .catch (err => {
                    this.loading = false;
                    this.reloading = false;
                    this.handleError(err);
                });
        },
        onRowSelect(event) {
            this.item = null;
            this.editar ({...event.data});
        },
        recarregar(page) {
            this.reloading = true;
            this.load(page);
        },
        loadOptions () {
            if ( this.selectOptions )
                return new Promise(function(resolve) {
                            resolve();
                        });

            let query = [];

            _.each(this.campos.data.edit_fields, (item) => {
                    if ( item.type == 'select' && item.aql )
                        query.push(item.aql);
                });

            _.each(this.campos.data.list_childs, (item) => {
                    _.each(item.metadados.edit_fields, (item) => {
                            if ( item.type == 'select' && item.aql )
                                query.push(item.aql);
                        });
                });

            query = { q: query };

            this.$store.commit('loading', true);

            return this.axios.post('aql', query)
                        .then (res => {
                            this.selectOptions = res.data;
                        })
                        .catch (err => {
                            this.handleError(err);
                        })
                        .finally (() => {
                            this.$store.commit('loading', false);
                        });
        },
        load (page = 1) {

            this.last_page = page;

            this.$store.commit('loading', true);

            let filtro_medico = ( this.id_medico && this.link ) ? { where: { id_pessoa: this.id_medico } } : {};

            let query = { q: [
                {
                    name: 'medicos.index',
                    id: "lista",
                    parms: {
                        search: this.search,
                        cadastro_medico: false,
                        ...filtro_medico,
                        cadastro: true,
                        filtro_certificado: this.filtro_certificado, 
                    }
                },
                {
                    name: 'medicos.create',
                    id: "campos"
                },
                {
                    name: 'financeiro.qtd_fornecedores',
                    id: "fornecs"
                },
            ]};

            this.axios.post('aql', query)
                .then (res => {
                    if (res.data && res.data.lista.status == 200) {
                        this.lista = res.data.lista;
                        this.campos = res.data.campos;
                        this.tem_fornecedores = res.data.fornecs.data > 0 ? true : false;

                        if ( this.loading && !this.setup ) {
                            this.breadcrumb = [
                                    { name: "Configurações", path: "/cadastros"},
                                    { name: "Prestadores", path: "/config/prestadores", method: this.fechar }
                                ];
                            this.$store.commit('setBreadcrumb', this.breadcrumb);
                        }

                        if ( this.id_medico && this.lista.data.length == 1 && !this.em_edicao ) {
                            this.editar (this.lista.data[0]);
                        }
                    }

                    this.loading = false;

                })
                .catch (err => {
                    this.loading = false;
                    this.reloading = false;
                    this.handleError(err);
                })
                .finally (() => {
                    this.$store.commit('loading', false);
                    this.firstLoadDone = true;
                });
        },
        pesquisar () {
            this.reloading = true;
            this.load ();
        },
        incluir () {
            this.validate = false;
            this.edicao = {
                _novo: true,
            };
        },
        atualizar () {

            this.$forceUpdate();

            // Duplicidade de Especialidade...

            if ( this.item.medico_especialidade ) {

                let testeDuplic = this.item.medico_especialidade.filter (item => !item.excluido );

                if ( testeDuplic.length != _.uniqBy(testeDuplic, 'id_especialidade').length ) {

                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Especialidade duplicada.",
                        life: 3000
                    });

                    return;
                }

            }

            //

            this.$util.atualizar (this, {
                service: 'medicos',
                dados: this.item,
                reload: true,
                toast: true,
                callback: item => {
                    this.loadOptions ('especialidades.index', this.optionsName, { ativadas: true });
                    this.editar (item);
                }
            });


        },
        excluir (item) {
            this.axios.delete('/api/' + this.$props.model + '/' + item[this.chave])
                .then (() => {
                    this.carregar(this.last_page);
                })
                .catch (err => this.handleError(err));
        },
        fechar () {
            if ( this.id_medico && this.link ) {
                this.$router.go(-1);
            } else {
                if( !this.setup ) {
                    this.$router.replace({ name: 'c-prestadores'});
                    this.$store.commit('setBreadcrumb', this.breadcrumb);
                }

                this.em_edicao = false;
                window.scrollTo(0,0);

                if ( !this.setup ) {
                    this.$nextTick(() => { 
                        this.$refs['pesquisa'].$refs.input.focus ();
                    });
                }
            }
        },
        resolve(path, obj) {
            return path.split('.').reduce(function(prev, curr) {
                return prev ? prev[curr] : null
            }, obj || self);
        },
        toggle_medico (item) {
            this.$store.commit('loading', true);

            let query = { q: [
                {
                    name: 'medico_unidades.toggle',
                    id: 'toggle',
                    parms: {
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => {
                    if ( res.data.toggle.status == 200 ) {
                        item = res.data.toggle.data;
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });


        }
    },
    mounted() {
        /*
        if ( this.id_medico && !this.link ) {
            this.link = true;
        }
        */

        if ( !this.setup ) {
           this.$refs['pesquisa'].$refs.input.focus ();

           this.$util.loadItem(this, { 
                service: 'enquetes',
                func: 'index', 
                parms: { 
                    where: { 
                        model_type: 'App\\azure\\medico', 
                        fl_ativo: 1, 
                    }
                }
            })
            .then(res => { 
                this.lista_enquetes = res;
            });

           this.$util.loadItem(this, {
                service: 'medicos',
                func: 'tags',
            })
            .then(res => {
                this.options_classes = res;
            });
        }

        this.model = this.$props.parentModel ? this.$props.parentModel : this.$route.params.model;
        this.load ();

    },

    updated () {
      $('[data-toggle="tooltip"]').tooltip();
    }
}

</script>
